import Service from './service';

export default class WagonService extends Service {
  baseApi = '/wagons';

  async getWagons(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }
}
